import { EventBus } from 'primevue/utils';

var ToastEventBus = EventBus();

export { ToastEventBus as default };
